var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "s-form-checkbox",
    attrs: {
      "for": _vm.name
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": _vm.name,
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.checked
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('change', $event.target.checked);
      }
    }
  }), _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }